equl(".block_product-accessories-info-inner-heading")

let tabaccessories = document.querySelectorAll(".block_product-accessories-tabs-tags-inner-list-info");
tabaccessories.forEach((event) => {
	event.addEventListener('click', (tab) => {
		let _this = tab.target;
		_this.closest(".block_product-accessories-tabs-tags-inner-list").querySelectorAll(".block_product-accessories-tabs-tags-inner-list-info").forEach(sib => {
			sib.classList.remove('active')
			let protabId = sib.getAttribute("id");
			document.querySelector(`.block_product-accessories-inner-tab-content[data-id="${protabId}"]`).classList.add("hidden");
            setTimeout( () => {
              equl(`.block_product-accessories-inner-tab-content[data-id="${protabId}"] .block_product-accessories-info-inner-heading`)
            },2000)
		});
		let ids = _this.getAttribute("id");
		_this.classList.add("active");
		document.querySelector(`.block_product-accessories-inner-tab-content[data-id="${ids}"]`).classList.remove("hidden");
     
	})
})


let tabViewmoew = document.querySelectorAll(".block_product-accessories-info-view-more");

tabViewmoew.forEach((event) => {
	event.addEventListener('click', (tab) => {
       let target = tab.target;
       target.closest(".block_product-accessories-inner-tab-content").querySelectorAll(".block_product-accessories-info").forEach(sib => {
         sib.classList.remove('hidden');
       })
       target.classList.add('hidden');
       target.closest(".block_product-accessories-inner-tab-content").querySelector(".block_product-accessories-info-hide-more").classList.remove("hidden");
            setTimeout( () => {
              equl(`.block_product-accessories-info-inner-heading`)
            },2000)
      
	})
})

let tabHideProduct = document.querySelectorAll(".block_product-accessories-info-hide-more");

tabHideProduct.forEach((event) => {
	event.addEventListener('click', (tab) => {
		let target = tab.target;
		target.closest(".block_product-accessories-inner-tab-content").querySelectorAll(".block_product-accessories-info").forEach(sib => {
			sib.classList.add('hidden');
		})

		let hidden = target.closest(".block_product-accessories-inner-tab-content").querySelectorAll(".block_product-accessories-info");
		for (var i = 0; i < 3; i++) {
			hidden[i].classList.remove("hidden");
		}

		target.classList.add('hidden');
		target.closest(".block_product-accessories-inner-tab-content").querySelector(".block_product-accessories-info-view-more").classList.remove("hidden");
               setTimeout( () => {
              equl(`.block_product-accessories-info-inner-heading`)
            },2000)
	})
})






